export const MORE_ARROW_BTN_CLASS = "more-btn";
export const NAV_BAR_CLASS = "navbar-dots";
export const NAV_BAR_RIGHT_SIDE_ELEMENTS_CLASS = "navbar-right-side-elements";
export const NAV_BAR_ITEMS_CLASS = "navbar-dots-items";
export const NAV_BAR_ELEMENTS = [
  ".navbar-brand",
  ".navbar-dots-items",
  "#block-amrestsearchblock",
  "#block-languageswitcher"
];
